import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as AdvisoryBoardOffersActions from './advisory-board-offers.actions';
import * as AdvisoryBoardOffersSelectors from './advisory-board-offers.selectors';
import { OfferWithImage } from '@/model/offer-with-image';

@Injectable({
  providedIn: 'root',
})
export class AdvisoryBoardOffersFacade {
  readonly offers$ = this.store.select(
    AdvisoryBoardOffersSelectors.selectAdvisoryBoardOffers,
  );
  readonly loading$ = this.store.select(
    AdvisoryBoardOffersSelectors.selectAdvisoryBoardOffersLoading,
  );
  readonly error$ = this.store.select(
    AdvisoryBoardOffersSelectors.selectAdvisoryBoardOffersError,
  );
  readonly categoryIds$ = this.store.select(
    AdvisoryBoardOffersSelectors.selectAdvisoryBoardOffersCategoryIds,
  );
  readonly offersCount$ = this.store.select(
    AdvisoryBoardOffersSelectors.selectAdvisoryBoardOffersCount,
  );

  constructor(private store: Store) {}

  loadAdvisoryBoardOffers(categoryIds: string[]): void {
    this.store.dispatch(
      AdvisoryBoardOffersActions.loadAdvisoryBoardOffers({ categoryIds }),
    );
  }

  clearAdvisoryBoardOffers(): void {
    this.store.dispatch(AdvisoryBoardOffersActions.clearAdvisoryBoardOffers());
  }
}
